import { ContainerLoader } from "../Loaders/ContainerLoader";

export const ClientTranslationsLoading = () => <ContainerLoader fullPage />;
